export enum SystemSettingsActionTypes {
	SUBSCRIBE_SYSTEM_SETTINGS = 'SUBSCRIBE_SYSTEM_SETTINGS',
	UPDATE_SYSTEM_SETTINGS = 'UPDATE_SYSTEM_SETTINGS',
}